<template>
    <app-layout title="Rollen">
        <template #header>
            <page-title title="Rollen" />
        </template>

        <template #pageContent>
            <div id="roles" >
                <Input type="search" placeholder="Rol zoeken" v-model="searchRole" name="search-role"/>
                <Table id="roles-overview" :values="filteredRoles">
                    <thead>
                    <Th id="name">Naam</Th>
                    <Th id="description">Omschrijving</Th>
                    <Th id="slug">Slug</Th>
                    <Th id="level">Niveau</Th>
                    <Th  :sort="false">Afdelingen</Th>
                    <Th  :sort="false">Rechten</Th>
                    <Th id="inheritable">Overerfbaar</Th>
                    <Th id="updated_at">Laatste wijziging</Th>
                    <Th :sort="false" class="text-right">
                        <Button
                            htmlType="a"
                            buttonClass="add"
                            size="small"
                            title="Rol toevoegen"
                            text="Rol toevoegen"
                            :href="route('admin.roles.create')"
                        />
                    </Th>
                    </thead>
                    <tbody v-if="filteredRoles.length > 0">
                        <tr v-for="role in state.sortedValues['roles-overview']" :key="role.id">
                            <Td v-if="role.deleted_at" class="line-through">{{ role.name }}</Td>
                            <Td v-else>{{ role.name }}</Td>
                            <Td>{{ role.description }}</Td>
                            <Td>{{ role.slug }}</Td>
                            <Td>{{ role.level }}</Td>
                            <Td>
                                <template v-for="department in role.departments">
                                    <badge :text="department.department" badgeClass="light"/>
                                </template>
                            </Td>
                            <Td>
                                <template v-for="permission in role.permissions">
                                    <badge :text="permission.name" badgeClass="light"/>
                                </template>
                            </Td>
                            <Td>{{ role.inheritable }}</Td>
                            <Td>{{ moment(role.updated_at).format('DD/MM/YYYY HH:mm') }}</Td>
                            <Td class="text-right">
                                <Button
                                    htmlType="a"
                                    buttonClass="show"
                                    size="small"
                                    title="Rol bekijken"
                                    text="Rol bekijken"
                                    :href="route('admin.roles.show', {'id':role.id})"
                                /><br>
                                <Button
                                    htmlType="a"
                                    buttonClass="edit"
                                    size="small"
                                    title="Rol aanpassen"
                                    text="Rol aanpassen"
                                    :href="route('admin.roles.edit', {'id':role.id})"
                                    v-if="role.deleted_at === null"
                                />
                            </Td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Td from '@/Components/Td.vue'
import Th from '@/Components/Th.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Input from '@/Components/Input.vue'
import Badge from '@/Components/Badge.vue'

import store from '@/store'
import moment from "moment";

export default {
    components: {
        AppLayout,
        PageTitle,
        Table,
        Td,
        Th,
        Button,
        Modal,
        Input,
        Badge,
    },
    props:[
        'role_list'
    ],
    data() {
        return {
            searchRole: '',
        };
    },
    setup (props){
        return {
            state: store.state,
            ...store,
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
        filteredRoles(){
            return this.role_list.filter(role => {
                return role.name.toLowerCase().includes(this.searchRole.toLowerCase()) ||
                    role.description.toLowerCase().includes(this.searchRole.toLowerCase())||
                    role.slug.toLowerCase().includes(this.searchRole.toLowerCase())
            })
        },
    },
}

</script>
